import { makeStyles } from "tss-react/mui"
import { Grid, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { StandardDialog } from "../../../../dialogs/StandardDialog"
import { StandardButton } from "../../../../buttons/StandardButton"
import { PriceChangesList } from "./PriceChangesList"
import { PriceChange } from "./helpers"

const useStyles = makeStyles()((theme) => ({
    container: {
        padding: ".5rem 4rem 1.5rem",
        gap: "2rem",
    },
    button: {
        borderRadius: "0.5rem",
        paddingLeft: "2rem",
        paddingRight: "2rem",
    },
    cancelButton: {
        color: theme.palette.tailwind.slate[800],
    },
    successButton: {
        background: theme.palette.tailwind.slate[800],
        borderColor: theme.palette.tailwind.slate[300],
    },
    updateDialogTitle: {
        padding: "2.5rem 2rem 0",
    },
}))

type PriceMismatchDialogProps = Readonly<{
    open: boolean
    handleCloseMainDialog: () => void
    handleChangePrices: () => void
    changes: ReadonlyArray<PriceChange>
    priceListName?: string
}>

export function PriceMismatchDialog({
    handleCloseMainDialog,
    handleChangePrices,
    changes,
    priceListName,
}: PriceMismatchDialogProps) {
    const { classes, cx } = useStyles()

    return (
        <LocalizedStrict
            id="create-order-order-summary-meeting-services-product-price-mismatch-dialog"
            attrs={{ dialogTitle: true }}
        >
            <StandardDialog
                open
                onClose={() => {}}
                maxWidthProp="sm"
                hideCloseIcon
                slotProps={{
                    root: {
                        sx: {
                            zIndex: 9999,
                        },
                    },
                }}
                subtitle={
                    <LocalizedStrict id="create-order-order-summary-meeting-services-product-price-mismatch-dialog-message">
                        <Typography variant="body1">
                            Some prices have changed since this order was created. Review below to continue.
                        </Typography>
                    </LocalizedStrict>
                }
                dialogTitle="Prices updated"
                updateDialogClasses={{
                    dialogTitleContainer: classes.updateDialogTitle,
                }}
            >
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    direction="column"
                    wrap="nowrap"
                    className={classes.container}
                >
                    <PriceChangesList changes={changes} priceListName={priceListName} />
                    <Grid
                        container
                        direction="row"
                        wrap="nowrap"
                        alignItems="center"
                        justifyContent="center"
                        gap="1rem"
                    >
                        <LocalizedStrict id="create-order-no-products-dialog-button-label-cancel">
                            <StandardButton
                                color="grey"
                                variant="outlined"
                                onClick={() => {
                                    handleCloseMainDialog()
                                }}
                                size="medium"
                                className={cx(classes.cancelButton)}
                                updateDefaultClasses={classes.button}
                            >
                                Go to home
                            </StandardButton>
                        </LocalizedStrict>
                        {handleChangePrices && (
                            <LocalizedStrict id="create-order-order-summary-meeting-services-product-price-mismatch-dialog-submit-button">
                                <StandardButton
                                    onClick={() => {
                                        handleChangePrices()
                                    }}
                                    size="medium"
                                    className={cx(classes.successButton)}
                                    updateDefaultClasses={classes.button}
                                >
                                    Update
                                </StandardButton>
                            </LocalizedStrict>
                        )}
                    </Grid>
                </Grid>
            </StandardDialog>
        </LocalizedStrict>
    )
}
